import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-bt-authorization-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule, MatButtonModule
  ],
  templateUrl: './bt-authorization-dialog.component.html',
  styleUrl: './bt-authorization-dialog.component.scss',
})
export class BtAuthorizationDialogComponent {

  readonly data = inject<any>(MAT_DIALOG_DATA);

}
